import { Fragment } from "react";
import SearchOrCreateSelectInput from "../../core/inputs/SearchOrCreateSelectInput";
import { InventoryLocationTypes } from "../../core/utils/enums";
import { shouldShowInventoryLocation } from "../utils/utils";


function getInventoryLocationObjectLabel(inventoryLocation) {
    return <Fragment>
        <span><strong>{inventoryLocation.name}</strong><br></br></span>
        {inventoryLocation.license_plate && <span className="select-label-secondary-level"><em>{inventoryLocation.license_plate}</em></span>}
    </Fragment>
}

function inventoryLocationToInventoryLocationOption(inventoryLocation) {
    return {value: inventoryLocation.id, label: getInventoryLocationObjectLabel(inventoryLocation), object: inventoryLocation}
}

function InventoryLocationSearchOrCreateSelect(props) {
    const currentLocationId = props.defaultSelected?.object?.id

    // Custom filter: show only active locations, plus the currently selected one if inactive
    const customFilter = (location) => shouldShowInventoryLocation(location, currentLocationId)

    return <SearchOrCreateSelectInput
        objectName="Location"
        getObjectLabel={getInventoryLocationObjectLabel}
        listEndpoint={DjangoUrls["inventory:api-inventory-locations-list"](window.MARKETPLACE_ENTITY_SLUG)}
        listEndpointKwargs={[
            ["location_type", InventoryLocationTypes.warehouse],
            ["location_type", InventoryLocationTypes.drop_point],
        ]}
        getDetailsEndpoint={(inventoryLocation) => DjangoUrls["inventory:api-inventory-locations-detail"](window.MARKETPLACE_ENTITY_SLUG, inventoryLocation.id)}
        customFilter={customFilter}
        {...props}
    />
}

export { inventoryLocationToInventoryLocationOption };
export default InventoryLocationSearchOrCreateSelect
